import { React, useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Select,
  Col,
  Row,
  Checkbox,
  Tooltip,
  Radio,
  Dropdown,
  Menu,
  Switch,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import alertBlue from "../../../Assets/Icons/alertBlue.svg";
import styled from "styled-components";
import { GlobalSet, Styled } from "../../pageStyled";
import warning from "../../../Assets/Icons/warning.png";
import trusted from "../../../Assets/Icons/trusted.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import { updateSheetSpecs } from "../../../Services/settingsServices";
import { DisabledButtonStyle } from "../../pageStyled";
const { Option } = Select;

const SheetOrderSpecDrawer = (props) => {
    const grainTypeData = ["Long Grain", "Short Grain"];
    const[grainType, setGrainType] = useState("");
    const[mixedGrain, setMixedGrain] = useState("");
    const[mixedGrainOptions,setMixedGrainOptions] = useState([]);
    const [response, setResponse] = useState();
    const [alert, setAlert] = useState(false);    
    const [isTouched, setIsTouched] = useState(false);
    const [form] = Form.useForm();

    const onClose = () => {
        setGrainType("");
        setMixedGrain("");
        setMixedGrainOptions([]);
        setIsTouched(false);
        props.onClose();
    };
    
    const onGrainChange = (e) => {
        setGrainType(e);
        setIsTouched(true);
    };

    const handleMixedGrainChange = (e) => {
        setMixedGrain(e.target.value);
        setIsTouched(true);
    };

    const onFinish = async (e) => {
      let req = {
        grain: e.grain === "Short Grain" ? "short" : "long",
        mixed_grain: e.mixedGrain === "disabled" ? false : true
      }

      try {
        const resp = await updateSheetSpecs(req);
        if (!resp.error) {
          setResponse(resp);
          setAlert(true);
          setTimeout(() => {
            setAlert(false);
            setIsTouched(false);
            props.onClose();
            setGrainType("");
            setMixedGrain("");
            setMixedGrainOptions([]);
          }, 2000);
        }
      } catch (error) {
        console.log(error);
        setAlert(true);
        if(error?.response?.status == 500){
          setResponse("Something went wrong. Please try again");
        } else{
          setResponse(error.response.data?.msg);
        }
        setTimeout(() => {
        setAlert(false);
        }, 3000);
      }    
    };

    useEffect(()=>{
        setMixedGrainOptions([{ label: "Active", value: "active" },
        { label: "Disabled", value: "disabled" }]);
        if(props?.sheetSpecData?.order_types[1]?.mixed_grain){
            setMixedGrain("active");
        } else{
            setMixedGrain("disabled"); 
        }
        if(props?.sheetSpecData?.order_types[1]?.grain === "long"){
            setGrainType("Long Grain");
        } else{
            setGrainType("Short Grain");
        }
    },[]);

    return (
    <RightDrawerSidebar
      title="Sheet Order Specifications"
      subtitle=""
      visible={props.visible}
      onClose={onClose}
    >
      {alert && (
        <AlertContainer
          color={response.error ? "red" : "green"}
          icon={response.error ? alertRed : alertGreen}
          msg={response.msg}
        />
      )}

      <RightDrawerContainer>
      <div className="resetPassForm removePadLeft">
      <DetailFields className="marginBtnP">
      <HaberForm> 
      <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                onFinish={onFinish}
                form={form}
              >
                {grainType && (<div className="drawerField">
                    <div className="titleWithText">
                      <h5>Grain</h5>
                      <p>The default grain for the sheet orders</p>
                    </div>
                    <Form.Item
                      name="grain"
                      initialValue={grainType}
                      rules={[
                        { required: true, message: "This field is required" },
                      ]}
                      className="selectForm"
                      style={{ marginBottom: 4 }}
                    >
                      <Select
                        placeholder={"Select"}
                        suffixIcon={<DownArrowDraw />}
                        onChange={onGrainChange}
                        disabled={!props?.roles?.edit}
                      >
                        {grainTypeData.map((grainType) => (
                          <Option key={grainType}>{grainType}</Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <div className="italicsTitleWithText">
                      <p>
                        {grainType === "Long Grain" ? "The shorter side will be matched in deckle" : "The longer side will be matched in deckle"}
                      </p>
                    </div>
                </div>)}

                {mixedGrain && <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Mixed Grain in Orders</h5>
                    <p>If enabled, users can choose to allow mixed grain for orders</p>
                  </div>
                    <Form.Item
                    name="mixedGrain"
                    initialValue={mixedGrain}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                    className=" switchRadio twoSwitch"
                    style={{ justifyContent: "center", display: "flex" }}
                    >
                    <Radio.Group
                      options={mixedGrainOptions}
                      optionType="button"
                      buttonStyle="solid"
                      value={mixedGrain}
                      onChange={handleMixedGrainChange}
                      disabled={!props?.roles?.edit}
                    />
                    </Form.Item>
                </div>}

                <div className="buttonFlex fixedBtm">
                  <Form.Item>
                  {!props?.roles?.edit || !isTouched ? (<DisabledButtonStyle>
                    <Button
                      htmlType="submit"
                      className={"themeBtn noBg disabledstyle"}
                      disabled={true}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Save
                    </Button>
                    </DisabledButtonStyle>): (<Button
                      htmlType="submit"
                      className={"themeBtn"}
                      // disabled={!props?.roles?.edit}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Save
                    </Button>
                    )}
                  </Form.Item>
                  </div>
              </Form>
      </HaberForm>
      </DetailFields>
      </div>
      </RightDrawerContainer>
    </RightDrawerSidebar>
    );
};
export default SheetOrderSpecDrawer;